import React from "react";
import PropTypes from "prop-types";
import {connect} from "react-redux";

import {removeToast} from "../../ducks/duck-screen";

import Toast from "./toast";


function ToastContainer(props) {
	return (
		<Toast {...props}/>
	);
}

ToastContainer.propTypes = {
	toast: PropTypes.object.isRequired,

	removeToast: PropTypes.func.isRequired,
}



export default connect(
	null,
	{
		removeToast
	}
)(ToastContainer);
